var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSomalia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0225C24.8366 32.0225 32 24.859 32 16.0225C32 7.1859 24.8366 0.0224609 16 0.0224609C7.16344 0.0224609 0 7.1859 0 16.0225C0 24.859 7.16344 32.0225 16 32.0225Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 8.37033L17.7269 13.6846H23.3146L18.794 16.969L20.5207 22.2834L16.0001 18.999L11.4795 22.2834L13.2062 16.969L8.68555 13.6846H14.2734L16.0001 8.37033Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0224609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomalia);
export default __webpack_public_path__ + "static/media/somalia.13613ecb.svg";
export { ForwardRef as ReactComponent };